import { CartAndOrder, OrderState } from "../../app/miscellaneous/orderAtom";
import { putOrderSubsetPlain } from "../../common-fetch/miscellaneous/putOrderSubsetPlain";
import { SetterOrUpdater } from "recoil";

export async function savePreferedCurrencyDetails(
  currency: string,
  order: CartAndOrder,
  setOrder: SetterOrUpdater<OrderState>,
  loadPage: () => void
) {
  await putOrderSubsetPlain(
    (latest: CartAndOrder) => {
      return {
        ...latest,
        siteLocale: {
          countryIso: order.siteLocale?.countryIso,
          currencyIso: currency,
          languageIso: order.siteLocale?.languageIso,
        },
      };
    },
    order,
    setOrder
  ).then((_orderResult) => {
    loadPage();
  });
}
